import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4584092e"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "group-transactions-view" }
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", null, "最新订单记录", -1))
const _hoisted_3 = ["src"]

import dayjs from "dayjs";
import {IconFont} from "@/lib/util";
import {RightOutlined} from "@ant-design/icons-vue";
import {editor} from "@/app/editor";


export default /*#__PURE__*/_defineComponent({
  __name: 'TransactionsView',
  setup(__props) {


const transaction = [{
  head_img_url: 'https://b.s.mywsy.cn/media/image/default_header.jpg',
  name: '张三',
  amount: 199,
  create_at: '2000-01-01'
}, {
  head_img_url: 'https://b.s.mywsy.cn/media/image/default_header.jpg',
  name: '张三',
  amount: 199,
  create_at: '2000-01-01'
}, {
  head_img_url: 'https://b.s.mywsy.cn/media/image/default_header.jpg',
  name: '张三',
  amount: 199,
  create_at: '2000-01-01'
}]

return (_ctx: any,_cache: any) => {
  const _component_a_flex = _resolveComponent("a-flex")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: "dot-divide",
      style: _normalizeStyle({'border-top-color': '#'+_unref(editor).activity!.data.themes.find(t => t.theme_id==_unref(editor).activity?.status.theme_props.theme_id)?.color})
    }, null, 4),
    _createVNode(_component_a_flex, {
      class: "transaction-title",
      align: "center",
      justify: "space-between"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(IconFont), { type: "icon-fire" }),
        _hoisted_2,
        _createElementVNode("span", null, [
          _createTextVNode("查看更多 "),
          _createVNode(_unref(RightOutlined))
        ])
      ]),
      _: 1
    }),
    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(transaction.slice(0, 3), (t, key) => {
      return (_openBlock(), _createBlock(_component_a_flex, {
        class: "transaction-item",
        key: key,
        justify: "space-evenly",
        align: "center"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_flex, {
            class: "transaction-item-head",
            align: "center",
            gap: "small"
          }, {
            default: _withCtx(() => [
              _createElementVNode("img", {
                src: t.head_img_url+'-sq.90',
                alt: ""
              }, null, 8, _hoisted_3),
              _createElementVNode("span", null, _toDisplayString(t.name), 1)
            ]),
            _: 2
          }, 1024),
          _createElementVNode("span", null, "已支付" + _toDisplayString(t.amount) + "元", 1),
          _createVNode(_component_a_flex, {
            vertical: "",
            class: "transaction-item-date",
            align: "flex-end",
            gap: "0"
          }, {
            default: _withCtx(() => [
              _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(t.create_at).format('YYYY-MM-DD')), 1),
              _createElementVNode("span", null, _toDisplayString(_unref(dayjs)(t.create_at).format('hh:mm:ss')), 1)
            ]),
            _: 2
          }, 1024)
        ]),
        _: 2
      }, 1024))
    }), 128))
  ]))
}
}

})